import {
  Translation,
  TRANSLOCO_CONFIG,
  TRANSLOCO_LOADER,
  TranslocoModule,
  TranslocoService,
} from '@ngneat/transloco';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { TranslocoCommonConfig } from './transloco.config';
import { AUTH_ROUTES_NEED_LOGGED, LanguagesService } from '../languages/services/languages.service';
import { TranslocoApiLoader } from './transloco.api-loader';
import { StartupConfigService } from 'projects/config/startup-config.service';
import { AuthService } from '../../auth/auth.service';

@NgModule({
  exports: [TranslocoModule],
  providers: [
    {
      // Provide the default Transloco configuration
      provide: TRANSLOCO_CONFIG,
      useClass: TranslocoCommonConfig
    },
    {
      // Provide the default Transloco loader
      provide: TRANSLOCO_LOADER,
      useClass: TranslocoApiLoader,
    },
    {
      // Preload the default language before the app starts to prevent empty/jumping content
      provide: APP_INITIALIZER,
      deps: [StartupConfigService, TranslocoService, LanguagesService, AuthService],
      useFactory:
        (
          startupConfigService: StartupConfigService,
          translocoService: TranslocoService,
          languagesService: LanguagesService,
          authService: AuthService,
        ): any => () => {
          const pagePath = () => location.pathname;
          const isNotFromAuthRouteWhichNeedBeLogged = () => AUTH_ROUTES_NEED_LOGGED.every((p) => !pagePath().includes(p));
          const isNotExpiredToken = () => !authService.getExpiredToken();
          return new Promise<any>((resolve) => {
            startupConfigService.ready$.subscribe(() => {
              authService.check().subscribe((authenticated) => {
                if (authenticated && isNotFromAuthRouteWhichNeedBeLogged() && isNotExpiredToken()) {
                  languagesService.applyAvailableLangsTo(translocoService);
                  resolve(null);
                  return;
                }

                const defaultLang = translocoService.getDefaultLang();
                translocoService.setActiveLang(defaultLang);
                languagesService.registerAvailableLang(translocoService, defaultLang);
                // AB#74965 - Transloco caches load() per language (shareReplay), so *transloco reuses this
                // request instead of starting the dictionary only after the lazy chunks. Errors are ignored
                // here because *transloco subscribes to the same load and handles them as it does today.
                translocoService.load(defaultLang).subscribe({ error: () => undefined });
                // AB#74965 - /Languages only feeds the language selector, so the bootstrap no longer waits
                // for it. On error the selector keeps only the default lang registered above.
                languagesService.getAll().subscribe({
                  next: (languages) => languagesService.applyAvailableLangsTo(translocoService, languages),
                  error: () => undefined,
                });
                resolve(null);
              });
            })
          });
        },
      multi: true,
    },
  ],
})
export class TranslocoCoreModule { }
